// // import React from "react";
// // import {
// //   MdOutlineEmail,
// //   MdOutlineLocalPhone,
// //   MdOutlineLocationOn,
// // } from "react-icons/md";
// // import { ADDRESS, HEAD_OFFICE } from "../constants";

// // const Contact = () => {
// //   return (
// //     <div style={{ minHeight: "100vh", background: "#FFFFFF" }}>
// //       {/* Header */}

// //       <header className="relative text-center text-white mb-10 py-28 px-4 overflow-hidden">
// //         <div className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/2172494039/photo/business-help-desk.webp?a=1&b=1&s=612x612&w=0&k=20&c=HFXKXdJ8vgfgpNcZXXC8bZ7svdZLE5qgSVTsNHDGcqw=')] bg-cover bg-center"></div>
// //         <div className="absolute  inset-0 bg-gradient-to-t from-black/60 via-black/60 to-black/60"></div>
// //         <div className="relative z-10 max-w-4xl mx-auto">
// //           <h1
// //             style={{
// //               fontSize: "2.7rem",
// //               fontWeight: 700,
// //               margin: 0,
// //               lineHeight: 1.2,
// //             }}
// //           >
// //             Connect with <span className="text-[#FFD700]">Salarymates</span>
// //           </h1>
// //           <p style={{ fontSize: "1.15rem", marginTop: 12, color: "#e0e0e0" }}>
// //             Whether you're looking for support or have general inquiries, our
// //             team is ready to help.
// //           </p>
// //         </div>
// //       </header>

// //       {/* Main Card */}
// //       <div
// //         style={{
// //           maxWidth: 1100,
// //           margin: "40px auto",
// //           background: "#fff",
// //           borderRadius: 18,
// //           boxShadow: "0 4px 24px 0 rgba(0,0,0,0.07)",
// //           padding: "40px 32px",
// //           display: "flex",
// //           flexDirection: "row",
// //           gap: 40,
// //           flexWrap: "wrap",
// //           border: "1px solid #E5E5E5",
// //         }}
// //       >
// //         {/* Left Column */}
// //         <div style={{ flex: 1, minWidth: 280, paddingRight: 16 }}>
// //           <h2
// //             style={{
// //               fontSize: "1.5rem",
// //               fontWeight: 700,
// //               color: "#1D3557",
// //               marginBottom: 18,
// //             }}
// //           >
// //             Contact Information
// //           </h2>
// //           <ul
// //             style={{ color: "#444", padding: 0, margin: 0, listStyle: "none" }}
// //           >

// //             <li style={{ marginBottom: 18 }}>
// //               <span style={{ fontWeight: 600, color: "#1D3557" }}>
// //                 Branch Address:
// //               </span>
// //               <br />
// //               Circular Road, Bhatti gate, Jhajjar, Haryana- 124103
// //             </li>
// //             <li style={{ marginBottom: 18 }}>
// //               <span style={{ fontWeight: 600, color: "#1D3557" }}>Email:</span>
// //               <br />
// //               <a
// //                 href="mailto:support@salarymates.in"
// //                 style={{ color: "#4FA0FF", textDecoration: "none" }}
// //               >
// //                 support@salarymates.in
// //               </a>
// //               <br />
// //               <a
// //                 href="mailto:salarymates@gmail.com"
// //                 style={{ color: "#4FA0FF", textDecoration: "none" }}
// //               >
// //                 salarymates@gmail.com
// //               </a>
// //             </li>
// //             <li style={{ marginBottom: 18 }}>
// //               <span style={{ fontWeight: 600, color: "#1D3557" }}>Phone:</span>
// //               <br />
// //               <a
// //                 href="tel:+91-9034006418 "
// //                 style={{ color: "#4FA0FF", textDecoration: "none" }}
// //               >
// //                 +91-9034006418 
// //               </a>
// //             </li>
// //             <li>
// //               <span style={{ fontWeight: 600, color: "#1D3557" }}>Hours:</span>
// //               <br />
// //               Monday to Saturday, 9:00 AM – 6:00 PM
// //             </li>
// //           </ul>
// //         </div>

// //         {/* Right Column - Contact Form */}
// //         <div style={{ flex: 1, minWidth: 280 }}>
// //           <form style={{ display: "flex", flexDirection: "column", gap: 20 }}>
// //             <div>
// //               <label
// //                 style={{
// //                   display: "block",
// //                   fontWeight: 600,
// //                   color: "#1D3557",
// //                   marginBottom: 6,
// //                 }}
// //               >
// //                 Your Name
// //               </label>
// //               <input
// //                 type="text"
// //                 name="name"
// //                 style={{
// //                   width: "100%",
// //                   border: "1px solid #E5E5E5",
// //                   borderRadius: 8,
// //                   padding: "12px 16px",
// //                   fontSize: "1rem",
// //                   outline: "none",
// //                   marginBottom: 0,
// //                 }}
// //                 placeholder="Enter your full name"
// //                 required
// //               />
// //             </div>
// //             <div>
// //               <label
// //                 style={{
// //                   display: "block",
// //                   fontWeight: 600,
// //                   color: "#1D3557",
// //                   marginBottom: 6,
// //                 }}
// //               >
// //                 Your Email
// //               </label>
// //               <input
// //                 type="email"
// //                 name="email"
// //                 style={{
// //                   width: "100%",
// //                   border: "1px solid #E5E5E5",
// //                   borderRadius: 8,
// //                   padding: "12px 16px",
// //                   fontSize: "1rem",
// //                   outline: "none",
// //                   marginBottom: 0,
// //                 }}
// //                 placeholder="example@domain.com"
// //                 required
// //               />
// //             </div>
// //             <div>
// //               <label
// //                 style={{
// //                   display: "block",
// //                   fontWeight: 600,
// //                   color: "#1D3557",
// //                   marginBottom: 6,
// //                 }}
// //               >
// //                 Your Message
// //               </label>
// //               <textarea
// //                 name="message"
// //                 rows={4}
// //                 style={{
// //                   width: "100%",
// //                   border: "1px solid #E5E5E5",
// //                   borderRadius: 8,
// //                   padding: "12px 16px",
// //                   fontSize: "1rem",
// //                   outline: "none",
// //                   marginBottom: 0,
// //                   resize: "vertical",
// //                 }}
// //                 placeholder="How can we help you?"
// //                 required
// //               ></textarea>
// //             </div>
// //             <button
// //               type="submit"
// //               style={{
// //                 width: "100%",
// //                 background: "#FFD700",
// //                 color: "#1D3557",
// //                 fontWeight: 600,
// //                 padding: "12px 0",
// //                 borderRadius: 8,
// //                 border: "none",
// //                 fontSize: "1rem",
// //                 marginTop: 8,
// //                 cursor: "pointer",
// //                 transition: "background 0.2s",
// //               }}
// //               onMouseOver={(e) =>
// //                 (e.currentTarget.style.background = "#FFE55C")
// //               }
// //               onMouseOut={(e) => (e.currentTarget.style.background = "#FFD700")}
// //             >
// //               Send Message
// //             </button>
// //           </form>
// //         </div>
// //       </div>

// //       <div className="max-w-[1300px] mx-auto py-20 px-5">
// //         <div className="mb-20">
// //           <h2 className="font-bold text-4xl md:text-5xl text-[#1D3557] text-center mb-10">
// //             For Business Contact
// //           </h2>
// //           {/* Table */}
// //           <div className="overflow-x-auto">
// //             <table className="w-full border border-[#E5E5E5] rounded-2xl shadow-lg overflow-hidden">
// //               <thead>
// //                 <tr className="bg-[#4FA0FF] text-white">
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[35%]">
// //                     Email
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[30%]">
// //                     Phone No.
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[35%]">
// //                     Address
// //                   </th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-[#E5E5E5]">
// //                 <tr className="hover:bg-gray-100 transition">
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     <span className="text-[#1D3557] font-medium">Email:- </span>{" "}
// //                     info@salarymates.in
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     <span className="text-[#1D3557] font-medium">Phone No:- </span>
// //                     +91-9034006418 
// //                   </td>

// //                   <td className="py-5 px-6 text-gray-700 leading-relaxed text-md md:text-lg">
// //                     <p>
// //                      Circular Road, Bhatti gate, Jhajjar, Haryana- 124103
// //                     </p>
// //                   </td>
// //                 </tr>
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>

// //         <div className="mb-20">
// //           <h2 className="font-bold text-4xl md:text-5xl text-[#1D3557] text-center mb-6">
// //             For Grievance Contact -{" "}
// //             <span className="text-[#FFD700]">Salarymates</span>
// //           </h2>
// //           <p className="text-gray-600 max-w-2xl mx-auto text-center mb-10 text-lg md:text-xl">
// //             We're here to help you. Reach out to us through any of the following
// //             channels and our team will assist you promptly.
// //           </p>

// //           {/* Table */}
// //           <div className="overflow-x-auto">
// //             <table className="w-full border border-[#E5E5E5] rounded-2xl shadow-lg overflow-hidden">
// //               <thead>
// //                 <tr className="bg-[#4FA0FF] text-white">
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[20%]">
// //                     Name
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md-text-lg w-[20%]">
// //                     Email
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md-text-lg w-[20%]">
// //                     Phone No.
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md-text-lg w-[40%]">
// //                     Address
// //                   </th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-[#E5E5E5]">
// //                 <tr className="hover:bg-gray-100 transition">
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     <h3 className="text-[#1D3557] font-medium">Mr. Ajay</h3>
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     grievances@salarymates.in
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     +91 9254069150
// //                   </td>

// //                   <td className="py-5 px-6 text-gray-700 leading-relaxed text-md md-text-lg">
// //                     <p>{ADDRESS}</p>
// //                   </td>
// //                 </tr>

// //                 <tr className="hover:bg-gray-100 transition">
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     <h3 className="text-[#1D3557] font-medium">Mr. Manjeet Singh</h3>
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     grievance.nodal@salarymates.in
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md-text-lg">
// //                     +91-9034006418 
// //                   </td>

// //                   <td className="py-5 px-6 text-gray-700 leading-relaxed text-md md-text-lg">
// //                     <p>{ADDRESS}</p>
// //                   </td>
// //                 </tr>
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>

// //         {/* ADDITRI SWAYAM SEVA MICRO CREDIT ASSOCIATION */}
// //         <div>
// //           <h2 className="font-bold text-4xl md:text-5xl text-[#1D3557] text-center mb-6">
// //             For Grievance Contact -
// //             <span className="text-[#FFD700]">ADDITRI SWAYAM SEVA MICRO CREDIT ASSOCIATION</span>
// //           </h2>
// //           <p className="text-gray-600 max-w-2xl mx-auto text-center mb-10 text-lg md:text-xl">
// //             We're here to help you. Reach out to us through any of the following
// //             channels and our team will assist you promptly.
// //           </p>

// //           {/* Table */}
// //           <div className="overflow-x-auto">
// //             <table className="w-full border border-[#E5E5E5] rounded-2xl shadow-lg overflow-hidden">
// //               <thead>
// //                 <tr className="bg-[#4FA0FF] text-white">
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[20%]">
// //                     Name
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[20%]">
// //                     Email
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[20%]">
// //                     Phone No.
// //                   </th>
// //                   <th className="py-5 px-6 font-semibold text-md md:text-lg w-[40%]">
// //                     Address
// //                   </th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-[#E5E5E5]">
// //                 <tr className="hover:bg-gray-100 transition">
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     <h3 className="text-[#1D3557] font-medium">
// //                       Mr. Ajay
// //                     </h3>
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     mr.ajay@kubermarg.com
// //                   </td>
// //                   <td className="py-5 px-6 text-gray-700 text-md md:text-lg">
// //                     +91 9254069150
// //                   </td>

// //                   <td className="py-5 px-6 text-gray-700 leading-relaxed text-md md:text-lg">
// //                     <p>
// //                       Address:Circular Road, Bhatti gate, Jhajjar, Haryana- 124103
// //                     </p>
// //                   </td>
// //                 </tr>

// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Map Section */}
// //       <section
// //         style={{
// //           maxWidth: 1100,
// //           margin: "48px auto",
// //           padding: "0 16px",
// //         }}
// //       >
// //         <h2
// //           style={{
// //             fontSize: "1.25rem",
// //             fontWeight: 700,
// //             color: "#1D3557",
// //             marginBottom: 16,
// //           }}
// //         >
// //           Visit Our Office
// //         </h2>
// //         <div
// //           style={{
// //             width: "100%",
// //             height: 350,
// //             borderRadius: 12,
// //             overflow: "hidden",
// //             boxShadow: "0 2px 12px 0 rgba(0,0,0,0.04)",
// //             border: "1px solid #E5E5E5",
// //           }}
// //         >
// //           <iframe
// //             title="Salarymates Office Location"
// //             style={{ width: "100%", height: "100%", border: 0 }}
// //             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27683.812318625836!2d76.65369031548517!3d28.60532021887385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d7065cf3e455b%3A0xa2b76c96db235a23!2sBhatti%20Gate%2C%20Jhajjar%2C%20Haryana%20124103!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
// //             allowFullScreen=""
// //             loading="lazy"
// //             referrerPolicy="no-referrer-when-downgrade"
// //           ></iframe>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default Contact;

// import React from "react";
// import {
//   MdOutlineEmail,
//   MdOutlineLocalPhone,
//   MdOutlineLocationOn,
// } from "react-icons/md";
// import { ADDRESS, HEAD_OFFICE } from "../constants";

// const Contact = () => {
//   return (
//     <div style={{ minHeight: "100vh", background: "#0B0F1A", color: "#E0E0E0" }}>
//       {/* Header */}
//       <header className="relative text-center mb-10 py-28 px-4 overflow-hidden">
//         <div className="absolute inset-0 bg-[url('https://media.istockphoto.com/id/2172494039/photo/business-help-desk.webp?a=1&b=1&s=612x612&w=0&k=20&c=HFXKXdJ8vgfgpNcZXXC8bZ7svdZLE5qgSVTsNHDGcqw=')] bg-cover bg-center opacity-60"></div>
//         <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F1A]/80 via-[#0B0F1A]/70 to-[#0B0F1A]/60"></div>
//         <div className="relative z-10 max-w-4xl mx-auto">
//           <h1 className="text-4xl md:text-5xl font-bold text-[#FFD700] mb-4">
//             Connect with Salarymates
//           </h1>
//           <p className="text-lg md:text-xl text-gray-300">
//             Whether you're looking for support or have general inquiries, our team is ready to help.
//           </p>
//         </div>
//       </header>

//       {/* Main Card */}
//       <div
//         className="max-w-5xl mx-auto p-10 rounded-2xl shadow-xl flex flex-wrap gap-8"
//         style={{ background: "#1A2035", border: "1px solid #2E3350" }}
//       >
//         {/* Left Column */}
//         <div className="flex-1 min-w-[280px]">
//           <h2 className="text-2xl font-bold text-[#FFD700] mb-6">Contact Information</h2>
//           <ul className="space-y-5 text-gray-300">
//             <li>
//               <MdOutlineLocationOn className="inline-block mr-2 text-[#4FA0FF]" />
//               <span className="font-semibold text-[#FFD700]">Branch Address:</span> Circular Road, Bhatti Gate, Jhajjar, Haryana- 124103
//             </li>
//             <li>
//               <MdOutlineEmail className="inline-block mr-2 text-[#4FA0FF]" />
//               <span className="font-semibold text-[#FFD700]">Email:</span> <a href="mailto:support@salarymates.in" className="text-[#4FA0FF] hover:underline">support@salarymates.in</a>, <a href="mailto:salarymates@gmail.com" className="text-[#4FA0FF] hover:underline">salarymates@gmail.com</a>
//             </li>
//             <li>
//               <MdOutlineLocalPhone className="inline-block mr-2 text-[#4FA0FF]" />
//               <span className="font-semibold text-[#FFD700]">Phone:</span> <a href="tel:+91-9034006418 " className="text-[#4FA0FF] hover:underline">+91-9034006418 </a>
//             </li>
//             <li>
//               <span className="font-semibold text-[#FFD700]">Hours:</span> Monday to Saturday, 9:00 AM – 6:00 PM
//             </li>
//           </ul>
//         </div>

//         {/* Right Column - Contact Form */}
//         <div className="flex-1 min-w-[280px]">
//           <form className="flex flex-col gap-5">
//             <input type="text" name="name" placeholder="Your Name" className="p-3 rounded-lg bg-[#2E3350] border border-[#4FA0FF] text-gray-200 focus:outline-none" required />
//             <input type="email" name="email" placeholder="Your Email" className="p-3 rounded-lg bg-[#2E3350] border border-[#4FA0FF] text-gray-200 focus:outline-none" required />
//             <textarea name="message" rows="4" placeholder="Your Message" className="p-3 rounded-lg bg-[#2E3350] border border-[#4FA0FF] text-gray-200 focus:outline-none resize-y" required />
//             <button
//               type="submit"
//               className="bg-[#FFD700] text-[#0B0F1A] font-bold py-3 rounded-lg hover:bg-[#FFE55C] transition"
//             >
//               Send Message
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Tables Section */}
//       <div className="max-w-6xl mx-auto py-16 px-4 space-y-16">
//         {/* Business Contact */}
//         <div>
//           <h2 className="text-3xl md:text-4xl font-bold text-center text-[#FFD700] mb-8">
//             For Business Contact
//           </h2>
//           <div className="overflow-x-auto">
//             <table className="w-full text-left border-collapse">
//               <thead>
//                 <tr className="bg-[#4FA0FF] text-white">
//                   <th className="py-4 px-6 rounded-tl-lg">Email</th>
//                   <th className="py-4 px-6">Phone No.</th>
//                   <th className="py-4 px-6 rounded-tr-lg">Address</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-600">
//                 <tr className="hover:bg-[#2E3350] transition">
//                   <td className="py-4 px-6">info@salarymates.in</td>
//                   <td className="py-4 px-6">+91-9034006418 </td>
//                   <td className="py-4 px-6">Circular Road, Bhatti Gate, Jhajjar, Haryana- 124103</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Grievance Contact */}
//         <div>
//           <h2 className="text-3xl md:text-4xl font-bold text-center text-[#FFD700] mb-6">
//             For Grievance Contact -Salarymates
//           </h2>
//           <p className="text-center text-gray-300 mb-6">
//             We're here to help you. Reach out to us through any of the following channels and our team will assist you promptly.
//           </p>
//           <div className="overflow-x-auto">
//             <table className="w-full text-left border-collapse">
//               <thead>
//                 <tr className="bg-[#4FA0FF] text-white">
//                   <th className="py-4 px-6">Name</th>
//                   <th className="py-4 px-6">Email</th>
//                   <th className="py-4 px-6">Phone No.</th>
//                   <th className="py-4 px-6">Address</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-600">
//                 <tr className="hover:bg-[#2E3350] transition">
//                   <td className="py-4 px-6">Mr. Ajay</td>
//                   <td className="py-4 px-6">grievances@salarymates.in</td>
//                   <td className="py-4 px-6">+91 9254069150</td>
//                   <td className="py-4 px-6">{ADDRESS}</td>
//                 </tr>
//                 <tr className="hover:bg-[#2E3350] transition">
//                   <td className="py-4 px-6">Mr. Manjeet Singh</td>
//                   <td className="py-4 px-6">grievance.nodal@salarymates.in</td>
//                   <td className="py-4 px-6">+91-9034006418 </td>
//                   <td className="py-4 px-6">{ADDRESS}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Map Section */}
//         <section className="max-w-6xl mx-auto mt-10">
//           <h2 className="text-xl font-bold text-[#FFD700] mb-4">Visit Our Office</h2>
//           <div className="w-full h-80 rounded-xl overflow-hidden shadow-lg border border-[#2E3350]">
//             <iframe
//               title="Salarymates Office Location"
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27683.812318625836!2d76.65369031548517!3d28.60532021887385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d7065cf3e455b%3A0xa2b76c96db235a23!2sBhatti%20Gate%2C%20Jhajjar%2C%20Haryana%20124103!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
//               className="w-full h-full border-0"
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//             ></iframe>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default Contact;

// import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Contact = () => {
  // Generate random positions for bubbles
  const bubbles = [...Array(15)].map((_, i) => ({
    id: i,
    size: Math.random() * 15 + 8,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: i * 0.15,
    duration: Math.random() * 12 + 15,
    opacity: Math.random() * 0.15 + 0.05,
  }));

  // Stagger children animations
  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 0.1, 0, 1] },
    },
  };

  return (
    // <div className="min-h-screen bg-gradient-to-b from-white via-[#F8FAF5] to-white text-gray-900 overflow-hidden relative">
    //   {/* Floating Elements */}
    //   <div className="absolute inset-0 pointer-events-none">
    //     <motion.div
    //       animate={{
    //         y: [0, -40, 0],
    //         x: [0, 30, 0],
    //         rotate: [0, 10, -10, 0],
    //       }}
    //       transition={{ duration: 25, repeat: Infinity, ease: "easeInOut" }}
    //       className="absolute top-20 left-[5%] w-72 h-72 bg-[#105840]/5 rounded-full blur-3xl"
    //     />
    //     <motion.div
    //       animate={{
    //         y: [0, 40, 0],
    //         x: [0, -30, 0],
    //         rotate: [0, -10, 10, 0],
    //       }}
    //       transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
    //       className="absolute bottom-20 right-[5%] w-96 h-96 bg-[#105840]/5 rounded-full blur-3xl"
    //     />
    //     <motion.div
    //       animate={{
    //         scale: [1, 1.3, 1],
    //         opacity: [0.2, 0.4, 0.2],
    //         rotate: [0, 180, 360],
    //       }}
    //       transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
    //       className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#105840]/5 rounded-full blur-3xl"
    //     />
    //   </div>

    //   {/* Floating Bubbles */}
    //   <div className="absolute inset-0 overflow-hidden pointer-events-none">
    //     {bubbles.map((bubble) => (
    //       <motion.div
    //         key={bubble.id}
    //         className="absolute rounded-full bg-[#105840]"
    //         style={{
    //           width: bubble.size,
    //           height: bubble.size,
    //           left: bubble.left,
    //           top: bubble.top,
    //           opacity: bubble.opacity,
    //         }}
    //         animate={{
    //           y: [0, -60, 0, 60, 0],
    //           x: [0, 40, -40, 30, 0],
    //           scale: [1, 1.4, 0.8, 1.3, 1],
    //           rotate: [0, 180, 360],
    //         }}
    //         transition={{
    //           duration: bubble.duration,
    //           repeat: Infinity,
    //           delay: bubble.delay,
    //           ease: "easeInOut",
    //         }}
    //       />
    //     ))}
    //   </div>

    //   {/* Top Wave - Curved Side Down, Plane Side Up */}
    //   <div className="absolute top-0 left-0 w-full pointer-events-none">
    //     <svg
    //       className="w-full h-32 md:h-40"
    //       viewBox="0 0 1440 200"
    //       preserveAspectRatio="none"
    //     >
    //       <motion.path
    //         animate={{
    //           d: [
    //             "M0,0 L1440,0 L1440,100 C1200,67 960,133 720,100 C480,67 240,133 0,100 L0,0 Z",
    //             "M0,0 L1440,0 L1440,133 C1200,100 960,167 720,133 C480,100 240,167 0,133 L0,0 Z",
    //             "M0,0 L1440,0 L1440,100 C1200,67 960,133 720,100 C480,67 240,133 0,100 L0,0 Z",
    //           ],
    //         }}
    //         transition={{ duration: 8, repeat: Infinity }}
    //         fill="#105840"
    //         fillOpacity="0.03"
    //       />
    //     </svg>
    //   </div>

    //   {/* Header with Animated Carousel */}
    //   <section className="relative overflow-hidden h-[450px]">
    //     {/* Working Slider */}
    //     <Slider
    //       dots={true}
    //       infinite={true}
    //       speed={1000}
    //       slidesToShow={1}
    //       slidesToScroll={1}
    //       autoplay={true}
    //       autoplaySpeed={5000}
    //       fade={true}
    //       arrows={false}
    //       className="h-[450px] w-full"
    //     >
    //       {/* Slide 1
    //       <div>
    //         <div
    //           className="w-full h-[450px] bg-cover bg-center"
    //           style={{ backgroundImage: "url('/images/ctabanner.jpg')" }}
    //         >
    //           <div className="w-full h-full bg-black/40"></div>
    //         </div>
    //       </div> */}
    //       {/* Slide 2 */}
    //       <div>
    //         <div
    //           className="w-full h-[450px] bg-cover bg-center"
    //           style={{ backgroundImage: "url('/images/customer-service.jpg')" }}
    //         >
    //           <div className="w-full h-full bg-black/40"></div>
    //         </div>
    //       </div>
    //       {/* Slide 2 */}
    //       <div>
    //         <div
    //           className="w-full h-[450px] bg-cover bg-center"
    //           style={{
    //             backgroundImage: "url('/images/customer-service-2.jpg')",
    //           }}
    //         >
    //           <div className="w-full h-full bg-black/40"></div>
    //         </div>
    //       </div>
    //     </Slider>

    //     {/* Content on top */}
    //     <motion.div
    //       className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4"
    //       initial={{ opacity: 0, y: -50 }}
    //       animate={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 1 }}
    //     >
    //       {/* Green Line Above Heading */}
    //       <motion.div
    //         initial={{ width: 0 }}
    //         animate={{ width: "80px" }}
    //         transition={{ duration: 0.8, delay: 0.3 }}
    //         className="h-1 bg-[#105840] mx-auto mb-6"
    //       />

    //       <h1 className="text-4xl md:text-6xl font-bold mb-4 text-white">
    //         Connect with <span className="text-[#105840]">Salarymates</span>
    //       </h1>

    //       <motion.p
    //         className="text-lg md:text-xl text-white/90 max-w-2xl"
    //         initial={{ opacity: 0 }}
    //         animate={{ opacity: 1 }}
    //         transition={{ delay: 0.5, duration: 1 }}
    //       >
    //         Whether you're looking for support or have general inquiries, our
    //         team is ready to help.
    //       </motion.p>
    //     </motion.div>
    //   </section>

    //   {/* Floating Wave Below Image Slider - Curved Side Down, Plane Side Up */}
    //   <div className="relative w-full pointer-events-none -mt-1">
    //     <svg
    //       className="w-full h-16 md:h-20"
    //       viewBox="0 0 1440 120"
    //       preserveAspectRatio="none"
    //     >
    //       <motion.path
    //         animate={{
    //           d: [
    //             "M0,0 L1440,0 L1440,64 C1200,96 960,32 720,64 C480,96 240,32 0,64 L0,0 Z",
    //             "M0,0 L1440,0 L1440,80 C1200,48 960,112 720,80 C480,48 240,112 0,80 L0,0 Z",
    //             "M0,0 L1440,0 L1440,64 C1200,96 960,32 720,64 C480,96 240,32 0,64 L0,0 Z",
    //           ],
    //         }}
    //         transition={{ duration: 8, repeat: Infinity }}
    //         fill="#105840"
    //         fillOpacity="0.05"
    //       />
    //       <motion.path
    //         animate={{
    //           d: [
    //             "M0,0 L1440,0 L1440,48 C1200,80 960,16 720,48 C480,80 240,16 0,48 L0,0 Z",
    //             "M0,0 L1440,0 L1440,64 C1200,32 960,96 720,64 C480,32 240,96 0,64 L0,0 Z",
    //             "M0,0 L1440,0 L1440,48 C1200,80 960,16 720,48 C480,80 240,16 0,48 L0,0 Z",
    //           ],
    //         }}
    //         transition={{ duration: 10, repeat: Infinity }}
    //         fill="#105840"
    //         fillOpacity="0.03"
    //       />
    //     </svg>
    //   </div>

    //   {/* Main Contact Section */}
    //   <section className="relative z-10 max-w-6xl mx-auto px-4 py-20 flex flex-col md:flex-row gap-10">
    //     {/* Contact Info */}
    //     <motion.div
    //       className="flex-1 bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100"
    //       initial={{ opacity: 0, x: -50 }}
    //       whileInView={{ opacity: 1, x: 0 }}
    //       transition={{ duration: 0.8 }}
    //       whileHover={{ y: -5 }}
    //     >
    //       {/* Green Line Above Heading */}
    //       <motion.div
    //         initial={{ width: 0 }}
    //         whileInView={{ width: "60px" }}
    //         transition={{ duration: 0.8 }}
    //         className="h-1 bg-[#105840] mb-6"
    //       />

    //       <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4">
    //         <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //         <span className="text-xs font-medium text-[#105840]">
    //           GET IN TOUCH
    //         </span>
    //       </div>

    //       <h2 className="text-3xl font-bold mb-6 text-gray-900">
    //         Contact <span className="text-[#105840]">Information</span>
    //       </h2>

    //       <ul className="space-y-5 text-gray-700">
    //         <li>
    //           <span className="font-semibold text-[#105840]">
    //             Branch Address:
    //           </span>
    //           <br />
    //           Circular Road, Bhatti Gate, Jhajjar, Haryana-124103
    //         </li>
    //         <li>
    //           <span className="font-semibold text-[#105840]">Email:</span>
    //           <br />
    //           <a
    //             href="mailto:support@salarymates.in"
    //             className="text-[#105840] hover:underline"
    //           >
    //             support@salarymates.in
    //           </a>
    //           <br />
    //           <a
    //             href="mailto:salarymates@gmail.com"
    //             className="text-[#105840] hover:underline"
    //           >
    //             salarymates@gmail.com
    //           </a>
    //         </li>
    //         <li>
    //           <span className="font-semibold text-[#105840]">Phone:</span>
    //           <br />
    //           <a
    //             href="tel:+91-9034006418 "
    //             className="text-[#105840] hover:underline"
    //           >
    //             +91-9034006418 
    //           </a>
    //         </li>
    //         <li>
    //           <span className="font-semibold text-[#105840]">Hours:</span>
    //           <br />
    //           Monday to Saturday, 9:00 AM – 6:00 PM
    //         </li>
    //       </ul>
    //     </motion.div>

    //     {/* Contact Form */}
    //     <motion.div
    //       className="flex-1 bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100"
    //       initial={{ opacity: 0, x: 50 }}
    //       whileInView={{ opacity: 1, x: 0 }}
    //       transition={{ duration: 0.8 }}
    //       whileHover={{ y: -5 }}
    //     >
    //       {/* Green Line Above Heading */}
    //       <motion.div
    //         initial={{ width: 0 }}
    //         whileInView={{ width: "60px" }}
    //         transition={{ duration: 0.8 }}
    //         className="h-1 bg-[#105840] mb-6"
    //       />

    //       <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4">
    //         <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //         <span className="text-xs font-medium text-[#105840]">
    //           SEND MESSAGE
    //         </span>
    //       </div>

    //       <h2 className="text-3xl font-bold mb-6 text-gray-900">
    //         Send Us <span className="text-[#105840]">a Message</span>
    //       </h2>

    //       <form className="flex flex-col gap-4">
    //         <input
    //           type="text"
    //           placeholder="Your Name"
    //           className="bg-gray-50 border border-gray-200 rounded-md p-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#105840] focus:ring-1 focus:ring-[#105840]/20 transition-all"
    //           required
    //         />
    //         <input
    //           type="email"
    //           placeholder="Your Email"
    //           className="bg-gray-50 border border-gray-200 rounded-md p-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#105840] focus:ring-1 focus:ring-[#105840]/20 transition-all"
    //           required
    //         />
    //         <textarea
    //           rows={4}
    //           placeholder="Your Message"
    //           className="bg-gray-50 border border-gray-200 rounded-md p-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#105840] focus:ring-1 focus:ring-[#105840]/20 transition-all"
    //           required
    //         ></textarea>
    //         <motion.button
    //           type="submit"
    //           className="bg-[#105840] hover:bg-[#0A4A30] text-white rounded-md p-3 font-semibold mt-2 transition-all shadow-md hover:shadow-lg"
    //           whileHover={{ scale: 1.02, y: -2 }}
    //           whileTap={{ scale: 0.98 }}
    //         >
    //           Send Message
    //         </motion.button>
    //       </form>
    //     </motion.div>
    //   </section>

    //   {/* Business Contacts Table */}
    //   <section className="relative z-10 max-w-6xl mx-auto px-4 py-10">
    //     <motion.div
    //       initial={{ opacity: 0, y: 30 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.8 }}
    //       viewport={{ once: true }}
    //       className="text-center mb-6"
    //     >
    //       {/* Green Line Above Heading */}
    //       <motion.div
    //         initial={{ width: 0 }}
    //         whileInView={{ width: "60px" }}
    //         transition={{ duration: 0.8 }}
    //         className="h-1 bg-[#105840] mx-auto mb-6"
    //       />

    //       <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4">
    //         <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //         <span className="text-xs font-medium text-[#105840]">BUSINESS</span>
    //       </div>

    //       <h2 className="text-3xl font-bold text-gray-900">
    //         For Business <span className="text-[#105840]">Contact</span>
    //       </h2>
    //     </motion.div>

    //     <motion.div
    //       className="overflow-x-auto"
    //       initial={{ opacity: 0, y: 30 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.8, delay: 0.2 }}
    //     >
    //       <table className="w-full bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
    //         <thead>
    //           <tr className="bg-[#105840] text-white">
    //             <th className="py-4 px-6 font-semibold">Email</th>
    //             <th className="py-4 px-6 font-semibold">Phone No.</th>
    //             <th className="py-4 px-6 font-semibold">Address</th>
    //           </tr>
    //         </thead>
    //         <tbody className="divide-y divide-gray-100">
    //           <tr className="hover:bg-[#105840]/5 transition-colors">
    //             <td className="py-4 px-6 text-gray-700">
    //               info@salarymates.in
    //             </td>
    //             <td className="py-4 px-6 text-gray-700">+91-9034006418 </td>
    //             <td className="py-4 px-6 text-gray-700">
    //               Circular Road, Bhatti Gate, Jhajjar, Haryana-124103
    //             </td>
    //           </tr>
    //         </tbody>
    //       </table>
    //     </motion.div>
    //   </section>

    //   {/* Grievance Contact */}
    //   <section className="relative z-10 max-w-6xl mx-auto px-4 py-10">
    //     <motion.div
    //       initial={{ opacity: 0, y: 30 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.8, delay: 0.2 }}
    //       viewport={{ once: true }}
    //       className="text-center mb-6"
    //     >
    //       {/* Green Line Above Heading */}
    //       <motion.div
    //         initial={{ width: 0 }}
    //         whileInView={{ width: "60px" }}
    //         transition={{ duration: 0.8 }}
    //         className="h-1 bg-[#105840] mx-auto mb-6"
    //       />

    //       <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4">
    //         <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //         <span className="text-xs font-medium text-[#105840]">
    //           GRIEVANCE
    //         </span>
    //       </div>

    //       <h2 className="text-3xl font-bold text-gray-900">
    //         For Grievance{" "}
    //         <span className="text-[#105840]">Contact - Salarymates</span>
    //       </h2>
    //     </motion.div>

    //     <motion.div
    //       className="overflow-x-auto"
    //       initial={{ opacity: 0, y: 30 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.8, delay: 0.4 }}
    //     >
    //       <table className="w-full bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
    //         <thead>
    //           <tr className="bg-[#105840] text-white">
    //             <th className="py-4 px-6 font-semibold">Name</th>
    //             <th className="py-4 px-6 font-semibold">Email</th>
    //             <th className="py-4 px-6 font-semibold">Phone No.</th>
    //             <th className="py-4 px-6 font-semibold">Address</th>
    //           </tr>
    //         </thead>
    //         <tbody className="divide-y divide-gray-100">
    //           <tr className="hover:bg-[#105840]/5 transition-colors">
    //             <td className="py-4 px-6 text-gray-700">Mr. Ajay</td>
    //             <td className="py-4 px-6 text-gray-700">
    //               grievances@salarymates.in
    //             </td>
    //             <td className="py-4 px-6 text-gray-700">+91 9254069150</td>
    //             <td className="py-4 px-6 text-gray-700">
    //               Circular Road, Bhatti Gate, Jhajjar, Haryana-124103
    //             </td>
    //           </tr>
    //           <tr className="hover:bg-[#105840]/5 transition-colors">
    //             <td className="py-4 px-6 text-gray-700">Mr. Manjeet Singh</td>
    //             <td className="py-4 px-6 text-gray-700">
    //               grievance.nodal@salarymates.in
    //             </td>
    //             <td className="py-4 px-6 text-gray-700">+91-9034006418 </td>
    //             <td className="py-4 px-6 text-gray-700">
    //               Circular Road, Bhatti Gate, Jhajjar, Haryana-124103
    //             </td>
    //           </tr>
    //         </tbody>
    //       </table>
    //     </motion.div>
    //   </section>

    //   {/* Google Map */}
    //   <section className="relative z-10 max-w-6xl mx-auto px-4 py-10">
    //     <motion.div
    //       initial={{ opacity: 0, y: 30 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.8, delay: 0.4 }}
    //       viewport={{ once: true }}
    //       className="mb-6"
    //     >
    //       {/* Green Line Above Heading */}
    //       <motion.div
    //         initial={{ width: 0 }}
    //         whileInView={{ width: "60px" }}
    //         transition={{ duration: 0.8 }}
    //         className="h-1 bg-[#105840] mb-6"
    //       />

    //       <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#105840]/5 border border-[#105840]/10 rounded-full mb-4">
    //         <span className="w-1.5 h-1.5 bg-[#105840] rounded-full animate-pulse" />
    //         <span className="text-xs font-medium text-[#105840]">LOCATION</span>
    //       </div>

    //       <h2 className="text-3xl font-bold text-gray-900">
    //         Visit <span className="text-[#105840]">Our Office</span>
    //       </h2>
    //     </motion.div>

    //     <motion.div
    //       className="w-full h-[400px] rounded-2xl overflow-hidden shadow-xl border border-gray-200"
    //       initial={{ opacity: 0 }}
    //       whileInView={{ opacity: 1 }}
    //       transition={{ duration: 0.8, delay: 0.6 }}
    //     >
    //       <iframe
    //         title="Salarymates Office Location"
    //         className="w-full h-full border-0"
    //         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27683.812318625836!2d76.65369031548517!3d28.60532021887385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d7065cf3e455b%3A0xa2b76c96db235a23!2sBhatti%20Gate%2C%20Jhajjar%2C%20Haryana%20124103!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
    //         allowFullScreen
    //         loading="lazy"
    //         referrerPolicy="no-referrer-when-downgrade"
    //       ></iframe>
    //     </motion.div>
    //   </section>

    //   {/* Bottom Wave */}
    //   <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //     <svg
    //       className="w-full h-32 md:h-40"
    //       viewBox="0 0 1440 200"
    //       preserveAspectRatio="none"
    //     >
    //       <motion.path
    //         animate={{
    //           d: [
    //             "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //             "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
    //             "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
    //           ],
    //         }}
    //         transition={{ duration: 8, repeat: Infinity }}
    //         fill="#105840"
    //         fillOpacity="0.03"
    //       />
    //     </svg>
    //   </div>

    //   <style jsx>{`
    //     @keyframes pulse {
    //       0%,
    //       100% {
    //         opacity: 0.5;
    //         transform: scale(1);
    //       }
    //       50% {
    //         opacity: 0.8;
    //         transform: scale(1.05);
    //       }
    //     }
    //     .animate-pulse {
    //       animation: pulse 2s ease-in-out infinite;
    //     }
    //     .delay-1000 {
    //       animation-delay: 1s;
    //     }
    //   `}</style>
    // </div>
    <div className="min-h-screen bg-[#0A1620] text-white overflow-hidden relative">
      {/* Animated Background Elements - Only Soft Blurs */}
      <div className="absolute inset-0 pointer-events-none">
        <motion.div
          animate={{
            y: [0, -40, 0],
            x: [0, 30, 0],
            scale: [1, 1.2, 1],
          }}
          transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
          className="absolute top-20 left-[5%] w-72 h-72 bg-[#2D5F7A]/20 rounded-full blur-3xl"
        />
        <motion.div
          animate={{
            y: [0, 40, 0],
            x: [0, -30, 0],
            scale: [1, 1.3, 1],
          }}
          transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
          className="absolute bottom-20 right-[5%] w-96 h-96 bg-[#7BC4E0]/20 rounded-full blur-3xl"
        />
        <motion.div
          animate={{
            scale: [1, 1.4, 1],
            opacity: [0.2, 0.5, 0.2],
            rotate: [0, 180, 360],
          }}
          transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#1E3B4A]/30 rounded-full blur-3xl"
        />
      </div>

      {/* Animated Top Wave */}
      <div className="absolute top-0 left-0 w-full pointer-events-none">
        <svg
          className="w-full h-32 md:h-40"
          viewBox="0 0 1440 200"
          preserveAspectRatio="none"
        >
          <motion.path
            animate={{
              d: [
                "M0,0 L1440,0 L1440,100 C1200,67 960,133 720,100 C480,67 240,133 0,100 L0,0 Z",
                "M0,0 L1440,0 L1440,133 C1200,100 960,167 720,133 C480,100 240,167 0,133 L0,0 Z",
                "M0,0 L1440,0 L1440,100 C1200,67 960,133 720,100 C480,67 240,133 0,100 L0,0 Z",
              ],
            }}
            transition={{ duration: 8, repeat: Infinity }}
            fill="#7BC4E0"
            fillOpacity="0.03"
          />
        </svg>
      </div>

      {/* Header with Animated Image */}
      <section className="relative overflow-hidden h-[450px]">
        <motion.div
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 10, repeat: Infinity, repeatType: "reverse" }}
          className="w-full h-[450px] bg-cover bg-center"
          style={{ backgroundImage: "url('/images/customer-service.jpg')" }}
        >
          <div className="w-full h-full bg-[#0A1620]/60"></div>
        </motion.div>

        {/* Content on top */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4"
        >
          {/* Animated Blue Line */}
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "80px" }}
            transition={{ duration: 1, delay: 0.3 }}
            className="h-1 bg-[#7BC4E0] mx-auto mb-6"
          />

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="text-4xl md:text-6xl font-bold mb-4 text-white"
          >
            Connect with <span className="text-[#7BC4E0]">Salarymates</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 1 }}
            className="text-lg md:text-xl text-[#CCE6F5] max-w-2xl"
          >
            Whether you're looking for support or have general inquiries, our
            team is ready to help.
          </motion.p>
        </motion.div>
      </section>

      {/* Animated Wave Below Image */}
      <div className="relative w-full pointer-events-none -mt-1">
        <svg
          className="w-full h-16 md:h-20"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <motion.path
            animate={{
              d: [
                "M0,0 L1440,0 L1440,64 C1200,96 960,32 720,64 C480,96 240,32 0,64 L0,0 Z",
                "M0,0 L1440,0 L1440,80 C1200,48 960,112 720,80 C480,48 240,112 0,80 L0,0 Z",
                "M0,0 L1440,0 L1440,64 C1200,96 960,32 720,64 C480,96 240,32 0,64 L0,0 Z",
              ],
            }}
            transition={{ duration: 8, repeat: Infinity }}
            fill="#7BC4E0"
            fillOpacity="0.03"
          />
        </svg>
      </div>

      {/* Main Contact Section */}
      <section className="relative z-10 max-w-6xl mx-auto px-4 py-20 flex flex-col md:flex-row gap-10">
        {/* Contact Info - Animated */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          whileHover={{ y: -5 }}
          className="flex-1 bg-[#1A2F3A] rounded-2xl p-8 shadow-lg border border-[#2D5F7A]/30"
        >
          {/* Animated Blue Line */}
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60px" }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-[#7BC4E0] mb-6"
          />

          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4">
            <motion.span
              animate={{ scale: [1, 1.5, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
            />
            <span className="text-xs font-medium text-[#7BC4E0]">
              GET IN TOUCH
            </span>
          </div>

          <h2 className="text-3xl font-bold mb-6 text-white">
            Contact <span className="text-[#7BC4E0]">Information</span>
          </h2>

          <ul className="space-y-5 text-[#CCE6F5]">
            <motion.li
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1 }}
            >
              <span className="font-semibold text-[#7BC4E0]">
                Branch Address:
              </span>
              <br />
              Floor No: Second Floor, Building No: 87/E, Road/Street: Model Town,
              Nearby Landmark: Near Jindal Chownk, City/Town/Village: Hisar,
              State: Haryana, PIN Code: 125001
            </motion.li>

            <motion.li
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 }}
            >
              <span className="font-semibold text-[#7BC4E0]">
                Communication Address:
              </span>
              <br />
              Floor No.: Third Floor, Building No./Flat No.: 55 Third Floor,
              Road/Street: Saidulajab, Nearby Landmark: Westend Marg,
              Locality/Sub Locality: Saidulajab, City/Town/Village: New Delhi,
              District: South Delhi, State: Delhi, PIN Code: 110030
            </motion.li>
            <motion.li
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 }}
            >
              <span className="font-semibold text-[#7BC4E0]">Email:</span>
              <br />
              <a
                href="mailto:support@salarymates.com"
                className="text-[#7BC4E0] hover:underline"
              >
                support@salarymates.com
              </a>
            </motion.li>
            <motion.li
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
            >
              <span className="font-semibold text-[#7BC4E0]">Phone:</span>
              <br />
              <a
                href="tel:+91-9034006418 "
                className="text-[#7BC4E0] hover:underline"
              >
                +91-9034006418 
              </a>
            </motion.li>
            <motion.li
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 }}
            >
              <span className="font-semibold text-[#7BC4E0]">Hours:</span>
              <br />
              Monday to Saturday, 9:00 AM – 6:00 PM
            </motion.li>
          </ul>
        </motion.div>

        {/* Contact Form - Animated */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          whileHover={{ y: -5 }}
          className="flex-1 bg-[#1A2F3A] rounded-2xl p-8 shadow-lg border border-[#2D5F7A]/30"
        >
          {/* Animated Blue Line */}
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60px" }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-[#7BC4E0] mb-6"
          />

          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4">
            <motion.span
              animate={{ scale: [1, 1.5, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
            />
            <span className="text-xs font-medium text-[#7BC4E0]">
              SEND MESSAGE
            </span>
          </div>

          <h2 className="text-3xl font-bold mb-6 text-white">
            Send Us <span className="text-[#7BC4E0]">a Message</span>
          </h2>

          <form className="flex flex-col gap-4">
            <motion.input
              whileFocus={{ scale: 1.02 }}
              type="text"
              placeholder="Your Name"
              className="bg-[#0F2128] border border-[#2D5F7A]/30 rounded-md p-3 text-white placeholder-[#8FAFC7] focus:outline-none focus:border-[#7BC4E0] focus:ring-1 focus:ring-[#7BC4E0]/20 transition-all"
              required
            />
            <motion.input
              whileFocus={{ scale: 1.02 }}
              type="email"
              placeholder="Your Email"
              className="bg-[#0F2128] border border-[#2D5F7A]/30 rounded-md p-3 text-white placeholder-[#8FAFC7] focus:outline-none focus:border-[#7BC4E0] focus:ring-1 focus:ring-[#7BC4E0]/20 transition-all"
              required
            />
            <motion.textarea
              whileFocus={{ scale: 1.02 }}
              rows={4}
              placeholder="Your Message"
              className="bg-[#0F2128] border border-[#2D5F7A]/30 rounded-md p-3 text-white placeholder-[#8FAFC7] focus:outline-none focus:border-[#7BC4E0] focus:ring-1 focus:ring-[#7BC4E0]/20 transition-all"
              required
            ></motion.textarea>
            <motion.button
              type="submit"
              whileHover={{ scale: 1.02, y: -2 }}
              whileTap={{ scale: 0.98 }}
              className="bg-[#2D5F7A] hover:bg-[#1E3B4A] text-white rounded-md p-3 font-semibold mt-2 transition-all shadow-md"
            >
              Send Message
            </motion.button>
          </form>
        </motion.div>
      </section>

      {/* SalaryMates Support */}
      <section className="relative z-10 max-w-6xl mx-auto px-4 py-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-6"
        >
          {/* Animated Blue Line */}
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60px" }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-[#7BC4E0] mx-auto mb-6"
          />

          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4">
            <motion.span
              animate={{ scale: [1, 1.5, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
            />
            <span className="text-xs font-medium text-[#7BC4E0]">SUPPORT</span>
          </div>

          <h2 className="text-3xl font-bold text-white">
            SalaryMates <span className="text-[#7BC4E0]">Support</span>
          </h2>
        </motion.div>

        {/* Scrollable container with hidden scrollbar */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="overflow-x-auto scrollbar-hide"
        >
          <table className="w-full bg-[#1A2F3A] rounded-2xl shadow-lg overflow-hidden border border-[#2D5F7A]/30">
            <thead>
              <tr className="bg-[#2D5F7A] text-white">
                <th className="py-4 px-6 font-semibold">Name</th>
                <th className="py-4 px-6 font-semibold">Phone No.</th>
                <th className="py-4 px-6 font-semibold">Support Timings</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#2D5F7A]/30">
              <motion.tr
                whileHover={{ backgroundColor: "#2D5F7A/20", scale: 1.01 }}
                className="transition-all"
              >
                <td className="py-4 px-6 text-[#CCE6F5]">Customer Support</td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  <a href="tel:+919034006418" className="hover:underline">
                    90538 88367
                  </a>
                </td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  Monday to Saturday, 9:00 AM – 7:00 PM
                </td>
              </motion.tr>
            </tbody>
          </table>
        </motion.div>
      </section>

      {/* Business Contacts Table */}
      <section className="relative z-10 max-w-6xl mx-auto px-4 py-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-6"
        >
          {/* Animated Blue Line */}
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60px" }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-[#7BC4E0] mx-auto mb-6"
          />

          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4">
            <motion.span
              animate={{ scale: [1, 1.5, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
            />
            <span className="text-xs font-medium text-[#7BC4E0]">BUSINESS</span>
          </div>

          <h2 className="text-3xl font-bold text-white">
            For Business <span className="text-[#7BC4E0]">Contact</span>
          </h2>
        </motion.div>

        {/* Scrollable container with hidden scrollbar */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="overflow-x-auto scrollbar-hide"
        >
          <table className="w-full bg-[#1A2F3A] rounded-2xl shadow-lg overflow-hidden border border-[#2D5F7A]/30">
            <thead>
              <tr className="bg-[#2D5F7A] text-white">
                <th className="py-4 px-6 font-semibold">Email</th>
                <th className="py-4 px-6 font-semibold">Phone No.</th>
                <th className="py-4 px-6 font-semibold">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#2D5F7A]/30">
              <motion.tr
                whileHover={{ backgroundColor: "#2D5F7A/20", scale: 1.01 }}
                className="transition-all"
              >
                <td className="py-4 px-6 text-[#CCE6F5]">
                  info@salarymates.com
                </td>
                <td className="py-4 px-6 text-[#CCE6F5]">+91-9034006418 </td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  SHOP NO-87 E, Gurudwara Road, MODEL TOWN, Gangwa, Hisar, Haryana, India - 125001
                </td>
              </motion.tr>
            </tbody>
          </table>
        </motion.div>
      </section>

      {/* LSP Grievance Contact */}
      <section className="relative z-10 max-w-6xl mx-auto px-4 py-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-6"
        >
          {/* Animated Blue Line */}
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60px" }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-[#7BC4E0] mx-auto mb-6"
          />

          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4">
            <motion.span
              animate={{ scale: [1, 1.5, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
            />
            <span className="text-xs font-medium text-[#7BC4E0]">
              LSP GRIEVANCE
            </span>
          </div>

          <h2 className="text-3xl font-bold text-white">
            For LSP{" "}
            <span className="text-[#7BC4E0]">Grievance Redressal</span>
          </h2>
        </motion.div>

        {/* Scrollable container with hidden scrollbar */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="overflow-x-auto scrollbar-hide"
        >
          <table className="w-full bg-[#1A2F3A] rounded-2xl shadow-lg overflow-hidden border border-[#2D5F7A]/30">
            <thead>
              <tr className="bg-[#2D5F7A] text-white">
                <th className="py-4 px-6 font-semibold">Contact Type</th>
                <th className="py-4 px-6 font-semibold">Email</th>
                <th className="py-4 px-6 font-semibold">Phone No.</th>
                <th className="py-4 px-6 font-semibold">Support Timings</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#2D5F7A]/30">
              <motion.tr
                whileHover={{ backgroundColor: "#2D5F7A/20", scale: 1.01 }}
                className="transition-all"
              >
                <td className="py-4 px-6 text-[#CCE6F5]">Grievance Officer</td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  <a
                    href="mailto:grievance@salarymates.com"
                    className="hover:underline"
                  >
                    grievance@salarymates.com
                  </a>
                </td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  90340 06418
                </td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  Monday to Saturday, 10:00 AM – 6:00 PM
                </td>
              </motion.tr>
              <motion.tr
                whileHover={{ backgroundColor: "#2D5F7A/20", scale: 1.01 }}
                className="transition-all"
              >
                <td className="py-4 px-6 text-[#CCE6F5]">Nodal Officer</td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  <a
                    href="mailto:grievance.nodal@salarymates.com"
                    className="hover:underline"
                  >
                    grievance.nodal@salarymates.com
                  </a>
                </td>
                <td className="py-4 px-6 text-[#CCE6F5]">

                </td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  Monday to Saturday, 10:00 AM – 6:00 PM
                </td>
              </motion.tr>
            </tbody>
          </table>
        </motion.div>
      </section>

      {/* Grievance Contact */}
      <section className="relative z-10 max-w-6xl mx-auto px-4 py-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-6"
        >
          {/* Animated Blue Line */}
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60px" }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-[#7BC4E0] mx-auto mb-6"
          />

          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4">
            <motion.span
              animate={{ scale: [1, 1.5, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
            />
            <span className="text-xs font-medium text-[#7BC4E0]">
              GRIEVANCE
            </span>
          </div>

          <h2 className="text-3xl font-bold text-white">
            For Grievance{" "}
            <span className="text-[#7BC4E0]">Contact - V.N. Credits Limited</span>
          </h2>
        </motion.div>

        {/* Scrollable container with hidden scrollbar */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="overflow-x-auto scrollbar-hide"
        >
          <table className="w-full bg-[#1A2F3A] rounded-2xl shadow-lg overflow-hidden border border-[#2D5F7A]/30">
            <thead>
              <tr className="bg-[#2D5F7A] text-white">
                <th className="py-4 px-6 font-semibold">Name</th>
                <th className="py-4 px-6 font-semibold">Email</th>
                <th className="py-4 px-6 font-semibold">Phone No.</th>
                <th className="py-4 px-6 font-semibold">Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#2D5F7A]/30">
              <motion.tr
                whileHover={{ backgroundColor: "#2D5F7A/20", scale: 1.01 }}
                className="transition-all"
              >
                <td className="py-4 px-6 text-[#CCE6F5]">Sakshi Jinsi</td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  grievance@vncredits.in
                </td>
                <td className="py-4 px-6 text-[#CCE6F5]">+91 93112 27994</td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  3/2, Amar Park, Zakhira, New Rohtak Road, New Delhi, Delhi, India - 110045
                </td>
              </motion.tr>
              <motion.tr
                whileHover={{ backgroundColor: "#2D5F7A/20", scale: 1.01 }}
                className="transition-all"
              >
                <td className="py-4 px-6 text-[#CCE6F5]">Amit Kumar (Nodal Officer)</td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  nodal@vncredits.in
                </td>
                <td className="py-4 px-6 text-[#CCE6F5]">+91 9311227994</td>
                <td className="py-4 px-6 text-[#CCE6F5]">
                  3/2, Amar Park, Zakhira, New Rohtak Road, New Delhi, Delhi, India - 110045
                </td>
              </motion.tr>
            </tbody>
          </table>
        </motion.div>
      </section>

      {/* Google Map
      <section className="relative z-10 max-w-6xl mx-auto px-4 py-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mb-6"
        >
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "60px" }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-[#7BC4E0] mb-6"
          />

          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#1E3B4A]/30 border border-[#2D5F7A]/30 rounded-full mb-4">
            <motion.span
              animate={{ scale: [1, 1.5, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-1.5 h-1.5 bg-[#7BC4E0] rounded-full"
            />
            <span className="text-xs font-medium text-[#7BC4E0]">LOCATION</span>
          </div>

          <h2 className="text-3xl font-bold text-white">
            Visit <span className="text-[#7BC4E0]">Our Office</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          whileHover={{ scale: 1.02 }}
          className="w-full h-[400px] rounded-2xl overflow-hidden shadow-xl border border-[#2D5F7A]/30"
        >
          <iframe
            title="Salarymates Office Location"
            className="w-full h-full border-0"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27683.812318625836!2d76.65369031548517!3d28.60532021887385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d7065cf3e455b%3A0xa2b76c96db235a23!2sBhatti%20Gate%2C%20Jhajjar%2C%20Haryana%20124103!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </motion.div>
      </section>
      */}

      {/* Animated Bottom Wave */}
      {/* <div className="absolute bottom-0 left-0 w-full pointer-events-none">
        <svg
          className="w-full h-32 md:h-40"
          viewBox="0 0 1440 200"
          preserveAspectRatio="none"
        >
          <motion.path
            animate={{
              d: [
                "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
                "M0,133 C300,100 600,167 900,133 C1200,100 1440,167 1440,133 L1440,200 L0,200 Z",
                "M0,100 C300,133 600,67 900,100 C1200,133 1440,67 1440,100 L1440,200 L0,200 Z",
              ],
            }}
            transition={{ duration: 8, repeat: Infinity }}
            fill="#7BC4E0"
            fillOpacity="0.03"
          />
        </svg>
      </div> */}


      <style jsx>{`
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`}</style>
    </div>
  );
};

export default Contact;
